export default __webpack_public_path__ + "static/media/mobile_containts-45.b6395b69.png";